//#region ../src/utils/validate-option-fields.ts
function clamp(value, min, max) {
	return Math.max(min, Math.min(max, value));
}
/**
* The `num` rule, extracted so the dispatch loop stays flat: reject anything
* that is not a finite number (a stored `NaN` is `typeof 'number'` and would
* survive the clamp), optionally round, then clamp.
*/
function resolveNum(value, constraint, round, fallback) {
	const finite = typeof value === "number" && Number.isFinite(value) ? value : fallback;
	return clamp(round ? Math.round(finite) : finite, constraint.min, constraint.max);
}
/**
* Validate one options group against its spec table.
*
* The output object's keys follow the SPEC's declaration order, so a group's
* serialized JSON stays byte-stable across save→validate round-trips — declare
* specs in the same order as the group's defaults.
*
* The casts inside the switch are contained here on purpose: TypeScript cannot
* correlate `T[K]` with the matched spec kind inside a generic loop. Call sites
* stay fully typed via {@link GroupSpec}.
*
* @param options Untrusted partial group (nullish is treated as "nothing set").
* @param defaults The group's defaults; every rejected field falls back here.
* @param specs One rule per field of `T`.
*/
function validateOptionFields(options, defaults, specs) {
	const input = options ?? {};
	const result = {};
	for (const key of Object.keys(specs)) {
		const spec = specs[key];
		const fallback = defaults[key];
		const value = input[key];
		switch (spec.kind) {
			case "bool":
				result[key] = typeof value === "boolean" ? value : fallback;
				break;
			case "num":
				result[key] = resolveNum(value, spec.constraint, spec.round, fallback);
				break;
			case "enum":
				result[key] = spec.values.includes(value) ? value : fallback;
				break;
			case "custom":
				result[key] = spec.resolve(input, fallback);
				break;
		}
	}
	return result;
}
//#endregion
export { validateOptionFields };
